import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';
import React, { Suspense } from 'react';

import { LeadFormMode } from '../../../../components/Forms/LeadGen/types';
import { WLHeading, WLText, WLTextV2 } from '../../..';
const LeadForm = React.lazy(
  () => import('../../../../components/Forms/LeadGen/LeadForm'),
);

interface GetStartedModalProps {
  open: boolean;
  onClose: () => void;
  refPage: string | null | undefined;
}

const GetStartedModal: React.FC<GetStartedModalProps> = ({
  open,
  onClose,
  refPage,
}) => {
  return (
    <Modal
      isCentered
      isOpen={open}
      onClose={onClose}
      scrollBehavior="inside"
      size={{ base: 'md', md: '3xl' }}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader />
        <ModalCloseButton />
        <ModalBody>
          <Suspense>
            <LeadForm
              mode={LeadFormMode.INDIVIDUAL}
              compact={false}
              refPage={refPage || ''}
              heading={() => (
                <>
                  <WLHeading level="h3" as={'h1'}>
                    Let’s Connect
                  </WLHeading>
                  <WLTextV2 marginBottom="8px">
                    When you choose WoodmenLife for life insurance or retirement
                    products, you’ll also get access to extras for your family.
                    Request a quote today so a Representative can contact you to
                    build a customized plan.
                  </WLTextV2>
                </>
              )}
              disclosures={() => (
                <WLText fontSize={'12px'} lineHeight="18px" color="gary.70">
                  All products may not be available in all states. This is a
                  solicitation of insurance and an agent may contact you. By
                  submitting the above request, I consent to receive phone calls
                  from a licensed insurance producer on behalf of Woodmen of the
                  World Life Insurance Society (WoodmenLife) and its affiliates
                  at the phone number(s) above regarding WoodmenLife products
                  and services. I understand that I can contact a Sales
                  Representative directly to make a purchase.
                </WLText>
              )}
              submitLabel={() => 'Submit'}
            />
          </Suspense>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default GetStartedModal;
